import "../styles/Projects.css"

import { Slide } from "react-awesome-reveal";
import Project from "./Project"
import projectImg from "../media/LogoPAGE (2).png"

function Projects() {
    return (
        <div className="project__page">
            <div className="project__page__inner">
                <div className="service__section">
                    <h1>OUR SERVICES</h1>
                    <Slide direction="right" triggerOnce="true">
                        <div className="service__list">
                            <div className="service one"><p>DESIGN</p></div>
                            <div className="service two"><p>MARKETING</p></div>          
                        </div>
                    </Slide>
                    <Slide direction="left" triggerOnce="true">
                        <div className="service__list">
                            <div className="service three"><p>WEBSITE</p></div>
                            <div className="service four"><p>EDITING</p></div>
                        </div>
                    </Slide>
                </div>
                <div className="project__section">
                    <h1>OUR WORK</h1>
                    <Slide direction="up" triggerOnce="true">
                        <div className="project__list">
                            <Project img={projectImg}/>
                        </div>
                    </Slide>
                </div>
            </div>
        </div>
    )
}

export default Projects
